function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.24322 13.3427C4.74618 13.8398 4.65984 14.5593 5.05037 14.9498C5.44089 15.3403 6.1604 15.254 6.65743 14.7569L14.757 6.65735C15.254 6.16032 15.3404 5.44081 14.9499 5.05029C14.5593 4.65976 13.8398 4.7461 13.3428 5.24314L5.24322 13.3427Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3427 14.7568C13.8398 15.2538 14.5593 15.3402 14.9498 14.9496C15.3403 14.5591 15.254 13.8396 14.7569 13.3426L6.65735 5.24298C6.16032 4.74595 5.44081 4.65961 5.05029 5.05014C4.65976 5.44066 4.7461 6.16017 5.24314 6.6572L13.3427 14.7568Z"
});

function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#908E8E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.820fc84f.svg";
export { ForwardRef as ReactComponent };